<!-- src/views/About.vue -->
<template>
    <div>
      <h1>Platform Page</h1>
      <!-- Your about page content goes here -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'PlatformPage',
  };
  </script>
  